import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-ChangeInOwnership',
    templateUrl: './ChangeInOwnership.component.html',
    styleUrls: ['./ChangeInOwnership.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeInOwnershipComponent implements OnInit, AfterViewInit {


  id: number;
  open=true;

  constructor(private actRoute: ActivatedRoute) {
    // this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {
  }

}
